import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapFinancialsData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateCreditReviewFinancialsMutation = (
	creditReviewId: string,
	refetchRecommendationInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: Function;
		}) => {
			return creditReviewDetailsService.updateFinancialsInfo(
				creditReviewId,
				mapFinancialsData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchRecommendationInfo();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateCreditReviewFinancialsMutation;
